let cn = {
    TENDERNO: "招标编号",
    DESCRIPTION: "描述",
    SUPPLIERNAME: "供应商",
    TENDERTYPE: "招标类型",
    TENDERTEMPLATE: "招标模板",
    CONTACT: "联系",
    ENDDATE: "最后日期",
    TOTALAMOUNT: "总金额",
    STATUS: "状态",
    DETAIL: "详细",
    ALL: "全部",
    WTQUOTE: "等待报价",
    COMPQUQTE: "已报价",
    BEAWARDED: "已中标",
    UNAWARDED: "未中标",
    CONFIRMED: "确认报价",
    SEARCHPLACEHOLDER: "输入招标编号或招标类型并搜索"
};
let tw = {
    TENDERNO: "招標編號",
    DESCRIPTION: "描述",
    SUPPLIERNAME: "供應商",
    TENDERTYPE: "招標類型",
    TENDERTEMPLATE: "招標模板",
    CONTACT: "聯係",
    ENDDATE: "最後日期",
    TOTALAMOUNT: "總金額",
    STATUS: "狀態",
    DETAIL: "詳細",
    ALL: "全部",
    WTQUOTE: "等待報價",
    COMPQUQTE: "已報價",
    BEAWARDED: "已中標",
    UNAWARDED: "未中標",
    CONFIRMED: "確認報價",
    SEARCHPLACEHOLDER: "輸入招標編號或招標類型並搜索"
};
let en = {
    TENDERNO: "Tender NO.",
    DESCRIPTION: "Description",
    SUPPLIERNAME: "Supplier Name",
    TENDERTYPE: "Tender Attribute",
    TENDERTEMPLATE: "Tender Template",
    CONTACT: "Contact",
    ENDDATE: "Closing Date",
    TOTALAMOUNT: "Total Amount",
    STATUS: "Status",
    DETAIL: "Detail",
    ALL: "All",
    WTQUOTE: "Waiting For Quotation",
    COMPQUQTE: "Submited",
    BEAWARDED: "Be Awarded",
    UNAWARDED: "Un Awarded",
    CONFIRMED: "Confirmed Pirce",
    SEARCHPLACEHOLDER: "Enter tender no or tender type of bid and search"
}

export {
    cn,
    tw,
    en
}